import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings<{
  accountDetails: {
    title: string;
    ibanLinkTitle: string;
  };
  activity: {
    title: string;
    transactions: string;
    statements: string;
  };
  credit: string;
  creditFromIban: string;
  creditFromWallet: string;
  paymentCards: {
    title: string;
  };
  seeAssociatedCard: string;
  seeAssociatedCards: string;
  transfer: string;
  transferToBeneficiary: string;
  transferToWallet: string;
  closeBankAccount: string;
}>({
  en: {
    accountDetails: {
      ibanLinkTitle: 'See dedicated IBAN',
      title: 'Bank details',
    },
    activity: {
      statements: 'Statements',
      title: 'Activity',
      transactions: 'Transactions',
    },
    closeBankAccount: 'Close the wallet',
    credit: 'Credit',
    creditFromIban: 'By sharing the IBAN',
    creditFromWallet: 'From one of my Shine wallets',
    paymentCards: {
      title: 'Payment cards',
    },
    seeAssociatedCard: 'See associated card',
    seeAssociatedCards: 'See associated cards',
    transfer: 'Transfer',
    transferToBeneficiary: 'To a beneficiary',
    transferToWallet: 'To one of my wallets',
  },
  fr: {
    accountDetails: {
      ibanLinkTitle: 'Voir l’IBAN dédié',
      title: 'Coordonnées bancaires',
    },
    activity: {
      statements: 'Relevés de compte',
      title: 'Activité',
      transactions: 'Transactions',
    },
    closeBankAccount: 'Clôturer le compte',
    credit: 'Créditer',
    creditFromIban: 'En partageant l’IBAN',
    creditFromWallet: 'Depuis un de mes comptes Shine',
    paymentCards: {
      title: 'Cartes bancaires',
    },
    seeAssociatedCard: 'Voir la carte associée',
    seeAssociatedCards: 'Voir les cartes associées',
    transfer: 'Transférer',
    transferToBeneficiary: 'Vers un·e bénéficiaire',
    transferToWallet: 'Vers un de mes comptes Shine',
  },
} as const);

export default locales;
